import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// Janelas/modais não fecham ao clicar fora (no fundo escuro) — só por Cancelar/X
window.addEventListener("click", (e) => {
  const t = e.target;
  if (t instanceof HTMLElement && t.classList.contains("fixed") && t.classList.contains("inset-0")
      && /(^|\s)bg-/.test(t.className)) {
    e.stopPropagation();
  }
}, true);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
